import { Button, createStyles } from '@mantine/core';
import { ReactComponent as ChevronIcon } from '../../assets/icons/chevron-down.svg';

export const NextButton = (props:any) => {
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  const { classes } = useStyles();
  const { disabled, onClick, children } = props;
  return (
    <Button
      type="button"
      disabled={disabled}
      className={`${classes.button} ${disabled ? classes.buttonDisabled : ''}`}
      onClick={onClick}
    >
      {children}
      <ChevronIcon />
    </Button>
  );
};

const useStyles = createStyles((theme) => ({
  button: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '8px',
    width: '118px',
    backgroundColor: theme.other.colors.primaryOld,
    borderRadius: '5px',
    border: 'none',
    color: theme.colors.grey[0],
    transition: 'all 0.5s ease',
    '&:disabled': {
      backgroundColor: theme.colors.grey[8],
      color: theme.colors.grey[4],
      '& path': {
        fill: theme.colors.grey[4],
      },
    },
    ':hover': {
      cursor: 'pointer',
      backgroundColor: `${theme.other.colors.primaryHover} !important`,
    },
  },
  buttonDisabled: {
    ':hover': {
      cursor: 'not-allowed',
      backgroundColor: theme.colors.grey[8],
    },
  },
}));

export default {};
